// Moldura das telas de dentro do app: barra do topo, conteúdo e abas.
import { h, icone } from '../lib/dom.js';
import { caminhoAtual } from '../rotas.js';
import { sessao } from '../sessao.js';
import { comPlaca } from './componentes.js';
import { barraDeSinal } from './sinal.js';

// [endereço, rótulo, ícone, outros endereços que acendem a mesma aba]
const ABAS = [
  ['/inicio', 'Início', 'inicio', []],
  ['/viagens', 'Viagens', 'rota', ['/cargas', '/vales']],
  ['/veiculos', 'Veículos', 'caminhao', ['/manutencao']],
  ['/colaboradores', 'Pessoas', 'pessoas', ['/regras', '/acertos']],
  ['/mais', 'Mais', 'menu', ['/clientes', '/conta', '/usuarios', '/pendencias', '/despesas', '/apagar', '/areceber', '/contas-fixas', '/relatorios', '/oficinas', '/sos']],
];

// App do motorista (entrou pelo link): só o que é dele, e o SOS.
const ABAS_DO_MOTORISTA = [
  ['/m', 'Início', 'inicio', []],
  ['/m/viagens', 'Viagens', 'rota', ['/m/cargas']],
  ['/m/despesas', 'Despesas', 'recibo', []],
  ['/m/saldo', 'Saldo', 'dinheiro', []],
  ['/sos', 'SOS', 'alerta', []],
];

// App do agenciador (0.21.0, entrou pelo link): as cargas dele, o que tem a
// receber e o Raio-X.
const ABAS_DO_AGENCIADOR = [
  ['/a', 'Início', 'inicio', []],
  ['/a/cargas', 'Cargas', 'rota', []],
  ['/a/receber', 'Receber', 'dinheiro', []],
  ['/a/raiox', 'Raio-X', 'grafico', []],
];

export function casca({ titulo, voltar = null, acoes = null, conteudo, abas = true }) {
  const atual = caminhoAtual();
  const lista = sessao.papel === 'motorista' ? ABAS_DO_MOTORISTA : sessao.papel === 'agenciador' ? ABAS_DO_AGENCIADOR : ABAS;
  // "/m" e "/a" são o Início do motorista e do agenciador: não valem como
  // começo de "/m/viagens" ou "/a/cargas".
  const ativa = (href, outros) => (href === '/m' || href === '/a'
    ? atual === href || atual.startsWith(`${href}?`)
    : [href, ...outros].some((c) => atual.startsWith(c)));
  return h('div', { class: `pagina${abas ? '' : ' sem-abas'}` },
    h('header', { class: 'topo' },
      h('div', { class: `topo-linha${voltar ? ' com-voltar' : ''}` },
        voltar && h('a', { class: 'botao-icone', href: `#${voltar}`, 'aria-label': 'Voltar' }, icone('voltar')),
        h('h1', null, comPlaca(titulo)),
        acoes),
      barraDeSinal()),
    h('main', { class: 'conteudo', id: 'conteudo', tabindex: '-1' }, conteudo),
    abas && h('nav', { class: 'abas', 'aria-label': 'Menu principal' },
      h('ul', null,
        lista.map(([href, rotulo, simbolo, outros]) =>
          h('li', null,
            h('a', { href: `#${href}`, class: href === '/sos' ? 'sos' : null, 'aria-current': ativa(href, outros) ? 'page' : null },
              icone(simbolo), rotulo))))));
}
